import {
	ChangeDetectionStrategy,
	Component,
	EventEmitter,
	HostListener,
	input,
	InputSignal,
	Output
} from "@angular/core";
import { ComponentsAngularModule } from "@bitpanda-design-system/angular";
import { NgOptimizedImage } from "@angular/common";
import { TranslationPipeModule } from "@modules/core/pipes/translation-pipe/translation-pipe.module";

export enum MtTypeSwitcherOption {
	MARGIN = "margin",
	LEVERAGE = "leverage"
}

@Component({
	selector: "mt-type-switcher",
	standalone: true,
	imports: [ComponentsAngularModule, NgOptimizedImage, TranslationPipeModule],
	templateUrl: "./mt-type-switcher.component.html",
	styleUrl: "./mt-type-switcher.component.scss",
	changeDetection: ChangeDetectionStrategy.OnPush
})
export class MtTypeSwitcherComponent {
	selectedOption: InputSignal<MtTypeSwitcherOption> = input(MtTypeSwitcherOption.MARGIN);
	maximumMarginLevel: InputSignal<number> = input(10);
	@Output("selectedOptionChange") selectedOptionChange: EventEmitter<MtTypeSwitcherOption> = new EventEmitter();
	@Output("selectboxClicked") selectboxClicked: EventEmitter<void> = new EventEmitter();

	switchType = MtTypeSwitcherOption;

	protected isOpen: boolean = false;

	protected select(option: MtTypeSwitcherOption): void {
		this.selectedOptionChange.emit(option);
		this.toggleDropdown();
	}

	protected toggleDropdown(): void {
		if (this.isOpen) {
			this.selectboxClicked.emit();
		}
		this.isOpen = !this.isOpen;
	}

	@HostListener("document:click", ["$event"])
	onOutsideClick(event: MouseEvent): void {
		const target = event.target as HTMLElement;
		if (!target.closest(".select")) {
			this.isOpen = false;
		}
	}
}
